import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { V2TabsComponent } from './v2-tabs.component';
import { V2TabDirective } from './tab/v2-tab.directive';
import { RoutedTabsComponent } from './routed-tabs/routed-tabs.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatTooltip, V2TabsComponent, V2TabDirective, RoutedTabsComponent],
  exports: [V2TabsComponent, V2TabDirective, RoutedTabsComponent]
})
export class V2TabsModule {}
